export default __webpack_public_path__ + "static/media/caishen_banking_app.d7def117.mp4";